import React, { useContext } from "react";
import { useLocation } from "react-router-dom";
import EnrollmentForm from "../components/EnrollmentForm";
import BlockHeader from "../components/BlockHeader";
import qrCodeEnrollmentTranslations from "../locales/qrCodeEnrollmentTranslations";
import { LanguageContext } from "../locales/LanguageContext";
import assessmentStatusEnum from "../utils/assessmentstatusEnum";
import { Helmet } from "react-helmet-async";

const QRCodeEnrollment = () => {
  const { lang } = useContext(LanguageContext);
  const t = qrCodeEnrollmentTranslations[lang] || {};
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const token = searchParams.get("token");

  if (!token) {
    return (
      <BlockHeader
        title={t.invalidTitle}
        icon="❌"
        subtitle={t.invalidSubtitle}
      />
    );
  }

  // The EnrollmentForm expects extraFields for QR: token and countryCurrencyId will be set by the form
  // We'll use a custom prop to show a QR-specific title and payment button
  return (
    <>
      <Helmet>
        <title>{t.pageTitle} | AKAAL KIDS</title>
      </Helmet>
      <div
        style={{
          width: "100%",
          background: "linear-gradient(90deg, #f6815e 0%, #f6b93b 100%)",
          color: "#fff",
          padding: "38px 0 24px 0",
          textAlign: "center",
          marginBottom: 32,
          boxShadow: "0 4px 24px #f6815e22",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <h1
          style={{
            fontWeight: 900,
            fontSize: "2.6rem",
            letterSpacing: 1,
            marginBottom: 11,
            textShadow: "0 2px 12px #f6815e55",
          }}
        >
          {t.pageTitle}
        </h1>
        <div style={{ fontSize: 20, fontWeight: 500, opacity: 0.96 }}>
          <span role="img" aria-label="profile">
            👤
          </span>{" "}
          {t.subtitle}
        </div>
      </div>
      <div
        className="container"
        style={{ fontSize: "1.18em", marginTop: -18, marginBottom: 24 }}
      >
        <EnrollmentForm
          endpoint="learner-enrollments/qr"
          extraFields={{
            token,
            assessmentStatus: assessmentStatusEnum.PASS,
            isQrEnrollment: true,
            configAppId: 3,
          }}
          showModalInfo={true}
          showSuccessMessage={false}
          submitButtonLabel={t.submitBtn}
          // Optionally, you can add a custom onSuccess to redirect to payment link if needed
          onSuccess={(res) => {
            if (res && res.paymentLink) {
              window.location.href = res.paymentLink;
            }
          }}
        />
      </div>
    </>
  );
};

export default QRCodeEnrollment;
